import React, { Component } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";

import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../store/validation/is-Empty";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Media from "react-media";

export class VendorLocatedInsideEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      selectedTab: 2,
      all_located_inside_icons: [],
      selected_located_inside: [],
      hasSetMapProps: false,
      loader: false,
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.located_inside) &&
      !nextState.hasSetMapProps
    ) {
      let selected_located_inside =
        nextProps.onboarding.selected_located_inside;
      if (!isEmpty(selected_located_inside[0])) {
        if (
          isEmpty(selected_located_inside[0]._id) &&
          selected_located_inside.length > 0
        ) {
          selected_located_inside = nextProps.located_inside.filter(
            (location) => selected_located_inside.includes(location._id)
          );
        }
      }
      return {
        all_located_inside_icons: nextProps.located_inside,
        selected_located_inside: !isEmpty(selected_located_inside)
          ? selected_located_inside
          : [],
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }
  /*********************************************
   * @DESC - onLocated Inside Array Selector
   *********************************************/
  onLocatedInsideArraySelector = (icon) => (e) => {
    e.preventDefault();
    let restaurantTypeArray = this.state.selected_located_inside;
    if (restaurantTypeArray.length === 0) {
      restaurantTypeArray.push(icon);
    } else {
      let isAlreadyPresent = restaurantTypeArray.some(
        (icons) => icons._id === icon._id
      );
      if (isAlreadyPresent) {
        let indexOf = restaurantTypeArray.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          restaurantTypeArray.splice(indexOf, 1);
        }
      } else {
        restaurantTypeArray.push(icon);
      }
    }
    this.setState({
      selected_located_inside: restaurantTypeArray,
      actionButton: true,
    });
  };

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: "/seatingdashboard",
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      vendor_id: this.props.onboarding.vendor_id,
      id: this.props.onboarding._id,
      selected_located_inside: this.state.selected_located_inside,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      // editButton: false,
      actionButton: false,
    });
  };

  renderLocatedInsideFields = (actionButton, allIcons, selectedIcons) => {
    const { editButton } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main margin-bottom-chains-onboarding">
          <div>
            <div className="cuisine-main ">
              {editButton === true ? (
                <div className="col-12 located-inside-heading-text">
                  <h3>Facility Is located inside Premises:</h3>
                  <p>
                    (If you are located within any building or facility select
                    below)
                  </p>
                </div>
              ) : null}
              <div
                className="cuisine-main-padding"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {allIcons.map((icon, index) => {
                  return (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection={
                        selectedIcons.some((icons) => icons._id === icon._id)
                          ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                          : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      }
                      src={icon.icon}
                      title={icon.title}
                      onClick={
                        editButton === true
                          ? this.onLocatedInsideArraySelector(icon)
                          : null
                      }
                    />
                  );
                })}
                <div className="suggest-button-heading">
                  <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d0e"} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 p-0 d-flex justify-content-between mt-5 mb-4">
            <ReusableOnboardingLink
              buttonTitle="Cancel Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Cancel"
              link="/profile"
            />
            {editButton === true ? (
              <ReusableOnboardingButton
                buttonTitle="Save Button"
                disabled={
                  isEmpty(this.state.selected_located_inside) ||
                  actionButton === false
                }
                buttonClass={`onboarding_button_link_reusable ${
                  isEmpty(this.state.selected_located_inside) ||
                  actionButton === false
                    ? "onboarding_button_link_reusable_gray"
                    : "onboarding_button_link_reusable_red"
                }`}
                buttonText="Save"
                onClick={actionButton === false ? this.onWithOutApiCall : null}
                buttonType={actionButton === false ? "button" : "submit"}
              />
            ) : null}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { editButton } = this.state;
    if (this.state.loader) {
      return <AmealioLoader />;
    }

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div className=" p-0">
                  <div>
                    <TopTextReusableComponent
                      headingText="Located Inside"
                      headingParagraph={
                        editButton === true
                          ? "Enter the information about your Restaurant."
                          : null
                      }
                      displayEdit={editButton}
                      onClickEdit={this.editClick}
                    />
                  </div>
                  <Form noValidate onSubmit={this.onHandleSubmit}>
                    {this.renderLocatedInsideFields(
                      this.state.actionButton,
                      this.state.all_located_inside_icons,
                      this.state.selected_located_inside
                    )}
                  </Form>
                </div>
              </div>
            </div>

            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorLocatedInsideEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  located_inside: state.category.located_inside,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(VendorLocatedInsideEdit));
